/* MAS builder cart guard.
   1. When a sword line's quantity changes, mirror it onto the hidden price-list line before the theme
      submits the cart form (the theme submits #cart_form ~1 s after a quantity change).
   2. Before checkout (cart page form or header mini-cart form), reconcile pairs through /cart.js:
      orphan price-list lines are removed, unequal quantities are fixed, and a sword whose price-list line
      is missing blocks checkout with a message. */
(function () {
  var BLOCKED = (document.documentElement.getAttribute('data-mas-cart-blocked') || 'Your cart is missing the options line for a custom sword. Please add the sword again.');

  function isOptions(item) { return item.product_type === 'mas_builder_pricelist'; }

  // Header cart count = swords only (the hidden price-list lines are not items to the customer). The Liquid
  // already renders this number; other scripts (MageWorx while it is installed) rewrite .cart_count from
  // cart.item_count, so keep re-applying ours whenever the text changes.
  fetch('/cart.js', { headers: { Accept: 'application/json' } })
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      var hidden = cart.items.filter(isOptions).reduce(function (n, it) { return n + it.quantity; }, 0);
      if (!hidden) return;
      var count = String(cart.item_count - hidden);
      var nodes = document.querySelectorAll('.cart_count');
      nodes.forEach(function (el) {
        var apply = function () { if (el.textContent.trim() !== count) el.textContent = count; };
        apply();
        new MutationObserver(apply).observe(el, { childList: true, characterData: true, subtree: true });
      });
    })
    .catch(function () {});

  // On the cart page: drop orphaned price-list lines (their sword is gone) and warn when a sword lost its
  // price-list line; both only happen if the cart was changed outside the theme's own controls.
  if (document.getElementById('cart_form')) {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var byLink = {}, updates = {}, missing = false;
        cart.items.forEach(function (it) {
          var l = it.properties && it.properties._mas_link;
          if (!l) return;
          byLink[l] = byLink[l] || {};
          byLink[l][isOptions(it) ? 'options' : 'sword'] = it;
        });
        Object.keys(byLink).forEach(function (l) {
          var p = byLink[l];
          if (p.options && !p.sword) updates[p.options.key] = 0;
          else if (p.sword && !p.options && p.sword.properties._mas_options_total && p.sword.properties._mas_options_total !== '$0.00') missing = true;
        });
        if (Object.keys(updates).length) {
          return fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ updates: updates })
          }).then(function () { window.location.reload(); });
        }
        if (missing) {
          var p = document.createElement('p');
          p.className = 'warning mas-cart-warning';
          p.textContent = BLOCKED;
          var form = document.getElementById('cart_form');
          form.parentNode.insertBefore(p, form);
        }
      })
      .catch(function () {});
  }

  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input.matches || !input.matches('input.quantity')) return;
    var line = input.closest('[data-mas-link]');
    if (!line || line.hasAttribute('data-mas-options')) return;
    var link = line.getAttribute('data-mas-link');
    var scope = input.closest('form') || document;
    scope.querySelectorAll('[data-mas-link="' + link + '"][data-mas-options] input.quantity').forEach(function (other) {
      other.value = input.value;
    });
  }, true);

  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !(f.id === 'cart_form' || f.classList.contains('js-cart_content__form'))) return;
    if (f.getAttribute('data-mas-checked') === '1') return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var submitter = e.submitter;

    function proceed() {
      f.setAttribute('data-mas-checked', '1');
      if (submitter && submitter.name && !f.querySelector('input[type=hidden][name="' + submitter.name + '"]')) {
        var h = document.createElement('input');
        h.type = 'hidden'; h.name = submitter.name; h.value = submitter.value || '1';
        f.appendChild(h);
      }
      f.submit();
    }

    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var byLink = {};
        cart.items.forEach(function (it) {
          var l = it.properties && it.properties._mas_link;
          if (!l) return;
          byLink[l] = byLink[l] || {};
          byLink[l][isOptions(it) ? 'options' : 'sword'] = it;
        });
        var updates = {}, blocked = false;
        Object.keys(byLink).forEach(function (l) {
          var p = byLink[l];
          if (p.options && !p.sword) updates[p.options.key] = 0;
          else if (p.sword && p.options && p.sword.quantity !== p.options.quantity) updates[p.options.key] = p.sword.quantity;
          else if (p.sword && !p.options) {
            var t = p.sword.properties._mas_options_total;
            if (t && t !== '$0.00') blocked = true;
          }
        });
        if (blocked) { alert(BLOCKED); window.location.reload(); return; }
        if (!Object.keys(updates).length) { proceed(); return; }
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates: updates })
        }).then(function () { window.location.reload(); });
      })
      .catch(function () { proceed(); });
  }, true);
})();
